import { render, staticRenderFns } from "./delivery-info.vue?vue&type=template&id=5462b05b&scoped=true"
import script from "./delivery-info.vue?vue&type=script&lang=js"
export * from "./delivery-info.vue?vue&type=script&lang=js"
import style0 from "./delivery-info.vue?vue&type=style&index=0&id=5462b05b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5462b05b",
  null
  
)

export default component.exports